import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=cde6231e&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cde6231e')) {
      api.createRecord('cde6231e', component.options)
    } else {
      api.reload('cde6231e', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=cde6231e&", function () {
      api.rerender('cde6231e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20f4MZMZR9awa/JS/pricehelp.vue"
export default component.exports